/* ──────────────────────────────────────────────────────────────────
   Neij — precise storefront search

   Shopify's semantic search scores every product against the query
   and never returns zero, so searching one ring returns the whole
   catalogue. Shopify's documented way to switch semantic matching
   off is to use search syntax, so we rewrite the query into
   field-scoped form before it is submitted.

   If the scoped search finds nothing, we fall back to the plain
   (semantic) query so misspellings and concept searches still land
   somewhere useful.
   ────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var SCOPE_MARK = 'title:';

  // "gold ring" -> (title:gold* OR tag:gold* OR product_type:gold*) AND (...)
  function scopeQuery(raw) {
    var t = (raw || '').trim();
    if (!t) return t;
    if (/[:*"()]/.test(t)) return t;   // customer used real syntax, leave it alone

    var parts = t.split(/\s+/).map(function (w) {
      w = w.replace(/[^0-9A-Za-z\u00C0-\u024F'-]/g, '');
      return w ? '(title:' + w + '* OR tag:' + w + '* OR product_type:' + w + '*)' : '';
    }).filter(Boolean);

    return parts.length ? parts.join(' AND ') : t;
  }

  // Pull the human words back out of a scoped query
  function humanise(scoped) {
    var words = [], re = /title:([^\s*)]+)\*/g, m;
    while ((m = re.exec(scoped)) !== null) words.push(m[1]);
    return words.join(' ');
  }

  // ---- 1. Scope the query on the way out --------------------------
  // Navigate ourselves rather than editing the input, so the customer
  // never sees the search syntax in the box they typed into.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/search') === -1) return;

    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    var raw = input.value;
    var scoped = scopeQuery(raw);
    if (!scoped || scoped === raw) return;   // nothing to do, let it submit

    e.preventDefault();

    // Keep every other field the form carries, swap only q
    var data;
    try {
      data = new URLSearchParams(new FormData(form));
    } catch (err) {
      data = new URLSearchParams();
    }
    data.set('q', scoped);

    var action = form.getAttribute('action') || '/search';
    location.assign(action.split('?')[0] + '?' + data.toString());
  }, true);

  // ---- Results page only ------------------------------------------
  if (location.pathname.indexOf('/search') === -1) return;

  var q = '';
  try { q = new URLSearchParams(location.search).get('q') || ''; } catch (err) { return; }

  // ---- 2. No exact match -> rerun as a plain semantic search -------
  // Two conditions, so a markup change can never cause a redirect loop.
  var isEmpty = !!document.querySelector('.empty-state') &&
                !document.querySelector('.product-list .product-card');

  if (isEmpty && q.indexOf(SCOPE_MARK) !== -1) {
    var plain = humanise(q);
    if (plain) {
      location.replace(location.pathname + '?q=' + encodeURIComponent(plain) + '#similar');
      return;
    }
  }

  // ---- 3. Label the fallback so it reads as intentional ------------
  if (location.hash === '#similar') {
    var header = document.querySelector('.section-header .v-stack') ||
                 document.querySelector('.section-header');
    if (header) {
      var note = document.createElement('p');
      note.className = 'neij-search-fallback';
      note.textContent = 'No exact matches. Showing similar pieces.';
      header.appendChild(note);
    }
  }
})();